import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
@Injectable()
export class ConfigurationService {
  private _configs: Configs;
  constructor(private http: HttpClient) {
  }
  get(): Observable<Configs> {
    if (this._configs) {
      return of(this._configs);
    }
    return this.http.get<Configs>('app/configuration').pipe(
      tap((resp: Configs) => {
        this._configs = resp;
      }));
  }
}
export class Configs {
  consistentTimeout: ConsistentTimeoutConfigurationModel;
  public constructor(init?: Partial<Configs>) {
    Object.assign(this, init);
  }
}
export class ConsistentTimeoutConfigurationModel {
  isEnabled?: boolean;
  sessionTimeOut?: number;
  modalLeadTime?: number;
  sessionExtendFrequency?: number;
  ssoExpiredSessionLocation?: string;
}
